import { render } from "./slide1.vue?vue&type=template&id=40e0f431&scoped=true"
import script from "./slide1.vue?vue&type=script&lang=js"
export * from "./slide1.vue?vue&type=script&lang=js"

import "./slide1.vue?vue&type=style&index=0&id=40e0f431&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e0f431"]])

export default __exports__